import { render, staticRenderFns } from "./AccountHolderWidgetBase.vue?vue&type=template&id=7b435441&scoped=true"
import script from "./AccountHolderWidgetBase.vue?vue&type=script&lang=ts"
export * from "./AccountHolderWidgetBase.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderWidgetBase.vue?vue&type=style&index=0&id=7b435441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b435441",
  null
  
)

export default component.exports